import { RouterProvider } from "react-router-dom";
import ThemeCustomization from "./themes";
import router from "./routes/router";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <ThemeCustomization>
      <RouterProvider router={router} />
       <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        pauseOnFocusLoss
      />
    </ThemeCustomization>
  );
}

export default App;
